import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { io, Socket } from 'socket.io-client';
import axios from 'axios';
import styled, { createGlobalStyle } from 'styled-components';
import AlertPlayer, { AlertShowData } from '../components/AlertPlayer';
import { getPublicApiUrl } from '../api';
import { useSeo } from '../hooks/useSeo';

const OverlayGlobalStyle = createGlobalStyle`
  html, body, #root {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: transparent !important;
  }
`;

const ErrorMsg = styled.div`
  color: #ff6b6b;
  font-family: sans-serif;
  padding: 1rem;
  font-size: 14px;
`;

const FILTER_MAP: Record<string, string> = {
  'auction-bid': 'auction_bid',
  follow: 'follow',
  sub: 'sub',
  raid: 'raid',
  bits: 'bits',
};

function getSocketBase() {
  return getPublicApiUrl().replace(/\/api\/?$/, '') || window.location.origin;
}

const OverlayPage: React.FC = () => {
  useSeo({ title: 'Overlay', noIndex: true });

  const { overlayKey, alertFilter } = useParams<{ overlayKey: string; alertFilter?: string }>();
  const [error, setError] = useState('');
  const filterType = useMemo(
    () => (alertFilter ? FILTER_MAP[alertFilter.toLowerCase()] || null : null),
    [alertFilter],
  );

  useEffect(() => {
    if (!overlayKey) return;

    let socket: Socket | null = null;
    let cancelled = false;

    const setup = async () => {
      try {
        const apiUrl = getPublicApiUrl();
        const params = alertFilter ? { filter: alertFilter } : {};
        await axios.get(`${apiUrl}/alerts/public/${overlayKey}/config`, { params });

        if (cancelled) return;

        socket = io(getSocketBase(), { path: '/api/socket.io' });
        socket.emit('join-overlay', { key: overlayKey });
        socket.on('alert:show', (data: AlertShowData) => {
          window.dispatchEvent(new CustomEvent('eugenial-alert', { detail: data }));
        });
      } catch {
        if (!cancelled) {
          setError('Overlay no encontrado o clave inválida.');
        }
      }
    };

    setup();

    return () => {
      cancelled = true;
      if (socket) {
        socket.emit('leave-overlay', { key: overlayKey });
        socket.disconnect();
      }
    };
  }, [overlayKey, alertFilter]);

  if (error) {
    return (
      <>
        <OverlayGlobalStyle />
        <ErrorMsg>{error}</ErrorMsg>
      </>
    );
  }

  return (
    <>
      <OverlayGlobalStyle />
      <AlertPlayer filterType={filterType} />
    </>
  );
};

export default OverlayPage;
